const steps = [
  {
    num: "01",
    icon: "ri-message-3-line",
    title: "告訴我們您的想法",
    desc: "填寫查詢表單或直接 WhatsApp 聯繫。告訴我們大概的目的地方向、出發人數、天數預算即可，不需要事先做功課。",
    detail: "通常 24 小時內回覆",
  },
  {
    num: "02",
    icon: "ri-draft-line",
    title: "顧問度身訂製草案",
    desc: "專屬旅遊顧問根據您的需求，設計 2–3 個不同方案供您參考，包含路線圖、預算估算及特色活動建議。",
    detail: "2–3 個方案比較",
  },
  {
    num: "03",
    icon: "ri-edit-2-line",
    title: "反覆修改直至滿意",
    desc: "完全免費修改，無次數限制。調整路線、增減天數、更換住宿——直至您完全滿意才確認行程，絕無壓力。",
    detail: "無限次免費修改",
  },
  {
    num: "04",
    icon: "ri-road-map-line",
    title: "出發，享受旅程",
    desc: "確認後我們全權處理跨境手續、臨時牌照、保險及行前資料包。您只需準備好心情，其他一切交給我們。",
    detail: "最快 3 天可出發",
  },
];

const CustomProcess = () => (
  <section id="process" className="py-24 bg-white">
    <div className="w-full px-6 lg:px-12">
      {/* Header */}
      <div className="text-center mb-16">
        <span className="text-orange-500 text-sm font-semibold tracking-wider uppercase mb-4 block">
          簡單四步驟
        </span>
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          您的夢想旅程，這樣成真
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          無需繁複規劃，一切交給我們。從您的第一個想法到出發，全程有專人跟進
        </p>
      </div>

      {/* Steps */}
      <div className="relative">
        {/* Connecting line (desktop) */}
        <div className="hidden lg:block absolute top-16 left-[12.5%] right-[12.5%] h-px bg-stone-200 z-0"></div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 relative z-10">
          {steps.map((step, i) => (
            <div key={step.num} className="flex flex-col items-center text-center group">
              {/* Circle */}
              <div className="relative mb-6">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center border-2 transition-all ${
                  i === 0
                    ? "bg-orange-500 border-orange-500"
                    : "bg-white border-stone-200 group-hover:border-orange-400"
                }`}>
                  <i className={`${step.icon} text-2xl ${i === 0 ? "text-white" : "text-gray-500 group-hover:text-orange-500"} transition-colors`}></i>
                </div>
                <div className={`absolute -top-2 -right-2 w-7 h-7 rounded-full text-xs font-bold flex items-center justify-center ${
                  i === 0 ? "bg-white text-orange-500 border-2 border-orange-200" : "bg-stone-100 text-gray-400"
                }`}>
                  {step.num}
                </div>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{step.desc}</p>
              <div className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium ${
                i === 0 ? "bg-orange-50 text-orange-600" : "bg-stone-50 text-gray-500"
              }`}>
                <i className="ri-time-line"></i>
                <span>{step.detail}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Social Proof Strip */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
        {[
          {
            quote: "顧問超級耐心，改了五六次都沒問題，最後行程完全係我想要嘅。",
            name: "陳先生",
            trip: "川藏線自訂 12 天",
            avatar: "https://public.readdy.ai/ai/img_res/064cbfdc4e509650d332b0e2d992cb2a.jpg",
          },
          {
            quote: "第一次自駕中國，完全唔識，但係顧問幫我由零開始設計，成行零煩惱！",
            name: "林小姐",
            trip: "新疆環線自訂 10 天",
            avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20woman%20in%20her%2030s%20with%20bright%20smile%2C%20modern%20casual%20style%2C%20clean%20light%20background%2C%20portrait%20photography&width=80&height=80&seq=802&orientation=squarish",
          },
          {
            quote: "一家四口出行，自訂行程最啱，節奏慢啲，仔女都玩得盡興。",
            name: "黃先生",
            trip: "青海湖親子自訂 8 天",
            avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20in%20his%2035s%20with%20confident%20smile%2C%20outdoor%20style%2C%20clean%20light%20background%2C%20portrait%20photography&width=80&height=80&seq=803&orientation=squarish",
          },
        ].map((t) => (
          <div key={t.name} className="bg-stone-50 rounded-2xl p-6 border border-stone-100">
            <div className="flex mb-3">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-orange-400 text-sm"></i>
              ))}
            </div>
            <p className="text-gray-700 text-sm leading-relaxed mb-5 italic">&ldquo;{t.quote}&rdquo;</p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="text-gray-900 text-sm font-semibold">{t.name}</p>
                <p className="text-gray-400 text-xs">{t.trip}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CustomProcess;
